import React from "react";
import { motion } from "framer-motion";
import { Mic, Music, PartyPopper } from "lucide-react";
import { WHATS_ON } from "../lib/venue";

const icons = [Mic, Music, PartyPopper];

export const WhatsOn = () => {
  return (
    <section
      id="whats-on"
      data-testid="whats-on-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#F5A623] font-semibold">
              / What's On
            </span>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#FDFBF7] uppercase mt-4 leading-[0.9]">
              Your week,
              <br />
              <span className="text-[#F5A623]">turned up.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#FDFBF7]/65 text-base leading-relaxed">
            Two regular nights you can lock in your diary, plus the kind of
            spontaneous chaos only a good local can deliver.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {WHATS_ON.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`whats-on-card-${i}`}
                className="group relative bg-[#111114] border border-white/10 p-8 hover:border-[#F5A623]/60 transition-colors duration-300 overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#F5A623]/0 group-hover:bg-[#F5A623]/10 blur-3xl transition-all duration-500" />
                <div className="relative flex items-start justify-between mb-8">
                  <Icon
                    size={40}
                    strokeWidth={1.5}
                    className="text-[#F5A623]"
                  />
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[#FDFBF7]/50 font-semibold">
                    {item.time}
                  </span>
                </div>
                <span className="text-xs uppercase tracking-[0.25em] text-[#F5A623] font-semibold">
                  {item.day}
                </span>
                <h3 className="font-display text-3xl sm:text-4xl uppercase mt-2 text-[#FDFBF7]">
                  {item.title}
                </h3>
                <p className="mt-4 text-[#FDFBF7]/65 leading-relaxed">
                  {item.blurb}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
